import { Box, Image } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { COMMON_WEB_PATH } from '../../../constant';
import useCheckLogin from '../../../hook/useCheckLogin';

const ReloadButton = () => {
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: '45px',
      md: '55px',
      xl: '65px'
    };
  }, []);

  const iconHeightSize = useMemo(() => {
    return {
      base: '40px',
      md: '50px',
      xl: '60px'
    };
  }, []);

  return (
    <Box
      onClick={() => {
        window.location.reload(); // 重新載入頁面
      }}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Image
        src={`${COMMON_WEB_PATH}/blue-layout/header/reload_icon.png`}
        height={iconHeightSize}
        //minW="50px"
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default ReloadButton;
